import { Box, Grid } from "@material-ui/core";
import React from "react";
import "./tenantLogin.less";
import logo from "../../public/img/common/Stream-Data-Centers_Logo_WHITE.svg";

import Login from "./signIn/signIn";
import SignUp from "./signUp/signUp";
import ContactUs from "./contactUs/contactUs";
import PasswordReset from "./PasswordReset/PasswordReset";
import { isMobile, isTablet } from "react-device-detect";

class TenantLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPage: "logIn",
      displayContactUsSection: false
    };
  }

  /** Reset Password */
  resetPassword = SwitchTo => {
    this.setState({ selectedPage: SwitchTo });
  };

  render() {
    const { selectedPage } = this.state;
    return (
      <div className={"background-container"}>
        <Box>
          <Grid
            container
            direction={"row"}
            justifyContent={"flex-start"}
            alignItems={"stretch"}
            className={
              isMobile === true || isTablet === true
                ? "login-grid-mobile"
                : "login-grid"
            }
          >
            {!(isMobile === true || isTablet === true) ? (
              <Grid item xs={12} md={8}>
                <div className={"login-flex-statement-div"}>
                  <div style={{ transform: "skewX(-43deg)" }}>
                    {"Committed to improving the data center "}
                    <br />
                    {"experience through exceptional people and service.\r"}
                  </div>
                </div>
              </Grid>
            ) : null}
            <Grid item xs={12} md={4}>
              <div
                className={
                  isMobile === true || isTablet === true
                    ? "login-area-glass-mobile"
                    : "login-area-glass"
                }
              >
                <Grid container>
                  <Grid item xs={12}>
                    <Box>
                      <div
                        className={
                          isMobile === true || isTablet === true
                            ? "login-body-mobile"
                            : "login-body"
                        }
                      >
                        <div>
                          <img src={logo} className={"login-page-logo"} />
                        </div>
                        {selectedPage == "password" ? (
                          <div className={"login-pages-nav-item"}>
                            {" "}
                            {"Forgot Password"}{" "}
                          </div>
                        ) : (
                          <div className={"login-pages-nav"}>
                            <div
                              className={
                                selectedPage == "logIn"
                                  ? "login-pages-nav-item white-bottom-border"
                                  : "login-pages-nav-item"
                              }
                              onClick={() => {
                                this.setState({ selectedPage: "logIn" });
                              }}
                            >
                              {"Log In\r"}
                            </div>
                            <div
                              className={
                                selectedPage == "signUp"
                                  ? "login-pages-nav-item white-bottom-border"
                                  : "login-pages-nav-item"
                              }
                              onClick={() => {
                                this.setState({ selectedPage: "signUp" });
                              }}
                            >
                              {"Sign Up\r"}
                            </div>
                            {this.state.displayContactUsSection && 
                            <div
                              className={
                                selectedPage == "ContactUs"
                                  ? "login-pages-nav-item white-bottom-border"
                                  : "login-pages-nav-item"
                              }
                              onClick={() => {
                                this.setState({
                                  selectedPage: "ContactUs"
                                });
                              }}
                            >
                              {"Contact Us\r"}
                            </div>
                            }
                          </div>
                        )}

                        <div className={"log-in-render-area"}>
                          {selectedPage == "logIn" ? (
                            <Login resetPassword={this.resetPassword} />
                          ) : null}
                          {selectedPage == "signUp" ? (
                            <SignUp resetPassword={this.resetPassword} />
                          ) : null}
                          {selectedPage == "ContactUs" ? (
                            <ContactUs resetPassword={this.resetPassword} />
                          ) : null}
                          {selectedPage == "password" ? (
                            <PasswordReset resetPassword={this.resetPassword} />
                          ) : null}
                        </div>
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            direction={"row"}
            justifyContent={"center"}
            alignItems={"flex-end"}
          >
            <Grid item xs={12}>
              <Box style={{ textAlign: "center" }}>
                <div
                  className={
                    isMobile === true || isTablet === true
                      ? "login-copyright-mobile"
                      : "login-copyright"
                  }
                >
                  {"© 2020 Stream Data Centers |"}{" "}
                  <a
                    href={"https://www.streamdatacenters.com/privacy-policy/"}
                    style={{ color: "#FFFFFF", textDecoration: "none" }}
                    rel={"noreferrer"}
                    target={"_blank"}
                  >
                    {"Privacy Policy\r"}
                  </a>
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
    );
  }
}

export default TenantLogin;
